
import { copyToClipboard } from 'quasar'
import { Component, Prop, Vue } from 'vue-property-decorator'

import BankSlipModel from '../models/BankSlip'

import EButton from './Button.vue'
import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EButton,
    EPaymentInfo,
  },
})
export default class BankSlip extends Vue {
  @Prop({ required: true }) readonly bankSlip!: BankSlipModel

  copied = false;

  private async copyBarcode() {
    const barcode = this.bankSlip.number.replace(/\D/g, '')

    try {
      await copyToClipboard(barcode)

      this.copied = true
      this.$emit('copy')
      setTimeout(() => { this.copied = false }, 1100)
    } catch (err) {
      console.error(err)
    }
  }
}
